import type {CoreExportFormat} from '@wix/document-services-types'
import {getPluginsRunner} from './pluginsRunner'
import {exportEml} from './formats/eml/exportEml'
import type {
    DecoratedExportFormat,
    DecorationPluginUtils,
    EmlConverterAPI,
    EmlExportContext,
    EmlExportFormat
} from './types'
import {NicknamesGenerator} from './utils/nicknamesGenerator'
import _ from 'lodash'

const packComponentDecorated = (
    componentExport: CoreExportFormat,
    {nicknameGenerator}: DecorationPluginUtils
): DecoratedExportFormat => {
    getPluginsRunner(componentExport, {nicknameGenerator}).pack()
    // this is correct casting
    return componentExport as unknown as DecoratedExportFormat
}

export * from './constants'
export * from './types'

const converter: EmlConverterAPI['converter'] = {
    pack: (coreComponentExport: CoreExportFormat, context: EmlExportContext = {}): EmlExportFormat => {
        const nicknameGenerator = new NicknamesGenerator()
        const componentsWithContext = _.mapValues(coreComponentExport.components, component => {
            if (context.componentsManifest?.[component.id]) {
                return {
                    ...component,
                    ...context.componentsManifest[component.id]
                }
            }
            return component
        })
        const decoratedExport = packComponentDecorated(
            {...coreComponentExport, components: componentsWithContext},
            {nicknameGenerator}
        )
        return exportEml(decoratedExport, {nicknameGenerator})
    }
}

export {converter}
